export default __webpack_public_path__ + "static/media/S4xSOLUTION.450b998f.jpg";